"use client";

import { Moon, Sun } from "lucide-react";
import { useAppShell } from "@/components/providers/app-providers";

/** Light/dark toggle. Cycles light -> dark -> light (system is the initial default only). */
export function ThemeToggle() {
  const { resolvedTheme, setTheme } = useAppShell();
  const isDark = resolvedTheme === "dark";

  return (
    <button
      type="button"
      onClick={() => setTheme(isDark ? "light" : "dark")}
      aria-label={isDark ? "Switch to light theme" : "Switch to dark theme"}
      aria-pressed={isDark}
      className="flex h-10 w-10 items-center justify-center rounded-control border border-border-subtle bg-surface-primary text-text-secondary shadow-[var(--shadow-subtle)] hover:bg-surface-secondary"
    >
      {isDark ? <Sun aria-hidden="true" size={16} /> : <Moon aria-hidden="true" size={16} />}
    </button>
  );
}
